import React, { createRef, useState } from 'react';
import { Header } from '../../components/layout/header';
import { PermissionApi } from '../../apis';
import { Table, TableRef } from '../../components/table/table';
import { Button, Dropdown, message, Modal } from 'antd';
import { PermissionForm, Role } from '../../components/permission/form';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { PermissionCode, useRole } from '../../hook/use-role';

const PermissionListScreen = () => {
  const tableRef = createRef<TableRef>();
  const [modal, contextHolder] = Modal.useModal();
  const [messageApi, contextHolderMessage] = message.useMessage();
  const PAGE_NAME = PermissionCode.ROLE;
  const [action, setAction] = useState<any>({
    payload: undefined,
    isloading: false,
  });

  const { check } = useRole();

  const column = columns({
    options: {
      isDelete: check.isDelete(PAGE_NAME),
      isUpdate: check.isEdit(PAGE_NAME),
    },
    setType: async (type: 'remove' | 'update', id: string) => {
      console.log('type :', tableRef.current);

      switch (type) {
        case 'update':
          setAction({
            isloading: true,
          });
          const res = await PermissionApi.get(id);
          setAction({
            payload: res,
            isloading: false,
          });
          break;
        case 'remove':
          modal.confirm({
            title: 'Устгах',
            icon: <ExclamationCircleOutlined />,
            content: 'Устгахдаа итгэлтэй байна уу!',
            okText: 'Тийм',
            cancelText: 'Үгүй',
            onOk: async () => {
              await PermissionApi.remove(id);
              tableRef.current?.reload();
              messageApi.success('Амжилттай устлаа');
            },
          });
          break;
        //
      }
    },
  });

  const onSubmit = async (values: any) => {
    const val = {
      name: values.name,
      rolePermissions: (values.rolePermissions || [])
        .filter((item: Role) => item?.code)
        .map((item: Role) => ({
          code: item.code,
          isView: item.isView,
          isCreate: item.isCreate,
          isReview: item.isReview,
          isUpdate: item.isUpdate,
          isDelete: item.isDelete,
          hasAccess: item.hasAccess ?? true,
        })),
    };
    try {
      if (action?.payload?.id) {
        await PermissionApi.update(action.payload.id, val);
      } else {
        await PermissionApi.create(val);
      }

      tableRef.current?.reload();
      setAction({ payload: undefined, isloading: false });
      message.success('Амжилттай');
    } catch (err: any) {
      message.error(err.message);
    }
  };

  return (
    <>
      {contextHolderMessage}
      {contextHolder}
      <div className="flex-col bg-white rounded-[8px] p-5 h-full">
        <Header
          title="Хандах эрхийн удирдлага"
          isGoBack={false}
          options={
            <Button onClick={() => setAction({ payload: {}, isloading: false })} type="primary">
              Нэмэх
            </Button>
          }
        />
        <Table ref={tableRef} columns={column} loadData={PermissionApi.list} />
      </div>

      {action.payload && (
        <Modal
          title="Хэрэглэгч"
          closable={{ 'aria-label': 'Custom Close Button' }}
          open={action.payload ? true : false}
          footer={null}
          width={700}
          onCancel={() =>
            setAction({
              payload: undefined,
              isloading: false,
            })
          }
        >
          <PermissionForm onSubmit={onSubmit} action={action} />
        </Modal>
      )}
    </>
  );
};

const columns: any = ({
  setType,
  options,
}: {
  setType: (type: 'remove' | 'update', id: string) => void;
  options: {
    isDelete: boolean;
    isUpdate: boolean;
  };
}) => [
  {
    title: '#',
    key: 'rowIndex',
    width: 70,
    align: 'center',
    render: (_: any, __: any, index: any) => index + 1,
  },
  {
    title: 'Овог нэр',
    render: (item: any, __: any, index: any) => <label>{item.name}</label>,
    key: 'name',
  },
  {
    key: 'rowIndex',
    width: 150,
    align: 'center',
    render: (item: any, _: any, index: any) => {
      if (!options?.isDelete && !options?.isUpdate) {
        return <></>;
      }

      let menus = [];

      if (options?.isUpdate === true) {
        menus.push({
          key: 'update',
          label: <span>Засах</span>,
          onClick: () => {
            console.log('item :', item);
            setType('update', item?.id!);
          },
        });
      }

      if (options?.isDelete === true) {
        menus.push({
          key: 'remove',
          label: <span className="text-red-500">Устгах</span>,
          onClick: () => setType('remove', item?.id!),
        });
      }

      return (
        <Dropdown
          trigger={['click']}
          menu={{
            items: menus,
          }}
          arrow
          placement="bottomLeft"
        >
          <Button type="default">Үйлдэл</Button>
        </Dropdown>
      );
    },
  },
];

export { PermissionListScreen };
